import { ReactElement, ReactNode, useState } from 'react'
import { Box, ListItemIcon, ListItemText, MenuItem, MenuList, Popover } from '@mui/material'

interface Item {
  label: string
  onClick: () => void
  icon: ReactNode
  disabled?: boolean
}

interface Props {
  children: ReactNode
  items: Item[]
  /**
   * Additional callback applied when opening context menu
   */
  onContext?: () => void
  disabled?: boolean
}

const ContextMenu = ({ children, items, onContext, disabled }: Props): ReactElement => {
  const [anchorPosition, setAnchorPosition] = useState<{ top: number; left: number } | undefined>(
    undefined,
  )

  const handleContextMenu = (e: React.MouseEvent) => {
    if (items.length === 0 || disabled) return

    e.preventDefault()
    e.stopPropagation()
    setAnchorPosition({ top: e.clientY, left: e.clientX })

    onContext?.()
  }

  return (
    <>
      <Box onContextMenu={handleContextMenu}>{children}</Box>

      <Popover
        open={!!anchorPosition}
        onClose={() => setAnchorPosition(undefined)}
        anchorPosition={anchorPosition}
        anchorReference="anchorPosition"
      >
        <MenuList>
          {items.map(item => (
            <MenuItem
              key={item.label}
              onClick={() => {
                item.onClick()
                setAnchorPosition(undefined)
              }}
              disabled={item.disabled}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText>{item.label}</ListItemText>
            </MenuItem>
          ))}
        </MenuList>
      </Popover>
    </>
  )
}

export default ContextMenu
